import React from "react";
import AuthInput from "../../../components/Input/AuthInput";
import TransactionReportItem from "./TransactionReportItem";
import CustomPagination from "../../../components/TablePagination/TablePagination";
import { getInvoicePartyName } from "../../../utils/invoice";

const ReportInvoiceList = ({
  invoices = [],
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
  searchText,
  setSearchText,
  searchInvoice,
  setSearchInvoice,
  namePlaceholder = "Search customer",
  emptyMessage = "No invoices found for this date.",
  editable = true,
}) => {
  const filtered = invoices.filter((dt) => {
    const nameMatched =
      searchText === ""
        ? true
        : getInvoicePartyName(dt)
            .toLowerCase()
            .startsWith(searchText.toLowerCase());
    const invoiceQuery = searchInvoice.trim().toLowerCase();
    const invoiceMatched =
      invoiceQuery === ""
        ? true
        : String(dt.invoice_no || "")
            .toLowerCase()
            .startsWith(invoiceQuery) ||
          String(dt.auto_invoice_no ?? "")
            .toLowerCase()
            .startsWith(invoiceQuery);
    return invoiceMatched && nameMatched;
  });

  if (!invoices.length) {
    return (
      <div className="w-full text-center text-muted py-10 text-lg">
        {emptyMessage}
      </div>
    );
  }

  return (
    <div className="flex flex-col w-full">
      <div className="flex flex-col justify-end items-end gap-2 mb-3">
        <AuthInput
          Value={searchText}
          setValue={setSearchText}
          placeholder={namePlaceholder}
        />
        <AuthInput
          Value={searchInvoice}
          setValue={setSearchInvoice}
          placeholder="Search invoice # or auto #"
        />
      </div>
      {filtered
        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
        .map((trans) => (
          <TransactionReportItem
            key={trans._id || trans.id}
            trans={trans}
            editable={editable}
          />
        ))}
      {filtered.length === 0 && (
        <div className="w-full text-center text-muted py-8 text-sm">
          No matches for your search.
        </div>
      )}
      <CustomPagination
        count={filtered.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={onPageChange}
        RowsPerPage={rowsPerPage}
        onRowsPerPageChange={onRowsPerPageChange}
      />
    </div>
  );
};

export default ReportInvoiceList;
